const map = {
	"./Link-WhatsApp.png": 24325,
	"./ban-bg.png": 77557,
	"./bank-image.png": 88314,
	"./banner.png": 80758,
	"./become-01.png": 86255,
	"./become-02.png": 64788,
	"./bg-banner-01.png": 12052,
	"./bg-banner-02.png": 33519,
	"./bg-banner.png": 42274,
	"./blog-banner.jpg": 51133,
	"./blur.png": 29635,
	"./categories-icon-01.png": 83390,
	"./categories-icon-02.png": 69141,
	"./categories-icon-03.png": 86252,
	"./categories-icon-04.png": 16419,
	"./categories-icon-05.png": 94842,
	"./categories-icon.png": 86080,
	"./category-bg.png": 29014,
	"./come-soon.png": 24918,
	"./course-01.png": 62887,
	"./course-02.png": 95852,
	"./course-03.png": 7477,
	"./course-04.png": 55418,
	"./course-arrow.png": 54967,
	"./course-bg.png": 66779,
	"./demo.png": 79753,
	"./deposit-01.jpg": 54342,
	"./deposit-01.png": 52354,
	"./deposit-02.jpg": 95761,
	"./deposit-02.png": 66361,
	"./deposit-03.jpg": 98388,
	"./deposit-03.png": 50608,
	"./deposit-04.jpg": 19199,
	"./deposit-04.png": 46479,
	"./deposit.png": 51748,
	"./error-01.png": 66350,
	"./error-02.png": 38149,
	"./error-bg.png": 48686,
	"./error-bg1.png": 11733,
	"./error.png": 76080,
	"./favicon.png": 90286,
	"./inner-banner.jpg": 49375,
	"./instructor-profile-bg.jpg": 92413,
	"./join.png": 24208,
	"./lead-01.png": 5032,
	"./lead-02.png": 67011,
	"./lead-03.png": 77178,
	"./lead-04.png": 29237,
	"./lead-05.png": 17612,
	"./lead-06.png": 84647,
	"./login-bg.png": 68305,
	"./login-img.png": 55319,
	"./net-icon-01.png": 20881,
	"./net-icon-02.png": 99770,
	"./net-icon-03.png": 47523,
	"./net-icon-04.png": 87628,
	"./object.png": 19621,
	"./plan.png": 39509,
	"./profile-bg.jpg": 71237,
	"./qute-01.png": 96007,
	"./qute.png": 73339,
	"./register-img.png": 99345,
	"./service-01.png": 30795,
	"./service-02.png": 77296,
	"./share.png": 43475,
	"./spheres.png": 12944,
	"./support-bg.png": 28067,
	"./trend-bg.png": 61187,
	"./user-bg-01.png": 67817,
	"./user-bg-02.png": 36850,
	"./user-love.jpg": 11156,
	"./video-bg.jpg": 9223,
	"./video-img-01.jpg": 96893,
	"./video.jpg": 67935
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6935;